import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'

import Button from '~/shared/atoms/Button'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 100%;
`

export const ReserveButton = styled(Button)`
  width: auto;

  ${mediaQueryUp('m')} {
    align-self: flex-start;
  }
`
